import { api } from '..';

export async function refreshToken() {
  const at = localStorage.getItem('at');
  const rt = localStorage.getItem('rt');
  const { access_token, refresh_token, error } = await api(
    'POST',
    `/auth/refresh-token`,
    {
      access_token: at,
      refresh_token: rt
    }
  );

  if (!error) {
    localStorage.setItem('at', access_token);
    localStorage.setItem('rt', refresh_token);
  }
}

export async function verify(payload) {
  return api('POST', '/auth/verify', payload, {lang:payload.lang});
}
export async function sendVerifyEmail(payload) {
  return api('POST', '/auth/send-verified-email', payload, {lang:payload.lang});
}
export async function sendResetPasswordEmail(payload) {
  return api('POST', '/auth/send-reset-password-email', payload, {lang:payload.lang});
}
export async function resetPassword(payload) {
  return api('POST', '/auth/reset-password', payload, {lang:payload.lang});
}
